export default __webpack_public_path__ + "static/media/IMG_9054 copie.84e2eda0.jpg";